module.exports = __webpack_public_path__ + "img/features-invite.0557bda7.svg";